module.exports = __webpack_public_path__ + "img/9891667196348_.pic@2x12.ed58666b.png";